import { getTheme } from '@conexasaude/conexa-hero'
import { PreScheduleCardTagLabelParams } from './PreScheduleCard.types'

export const PRE_SCHEDULE_CARD_TAG_LABELS = ({
  confirmationLimitDate,
}: PreScheduleCardTagLabelParams) => {
  const theme = getTheme()

  return {
    isMoreThan48Hours: {
      label: 'Confirme até 24h antes',
      background: 'primary',
      color: theme.colors.brand.primary[400],
    },
    isLessThan48Hours: {
      label: confirmationLimitDate.toFormat("'Confirme até' dd/MM 'às' HH:mm"),
      background: 'error',
      color: theme.colors.feedback.error[400],
    },
    creationDateLessThan1Hour: {
      label: confirmationLimitDate.toFormat("'Confirme até' dd/MM 'às' HH:mm"),
      background: 'error',
      color: theme.colors.feedback.error[400],
    },
    creationDateLessThan24Hours: {
      label: 'Confirme até 1h antes',
      background: 'primary',
      color: theme.colors.brand.primary[400],
    },
    isExpired: {
      label: '',
      background: '',
      color: '',
    },
  }
}

export const ONE_MILLISECOND = 1000

export const PRE_SCHEDULE_CARD_SCREEN_EVENT = {
  PAC_RESERVA_CANCELAR: 'Pac_Reserva_Cancelar',
  PAC_RESERVA_CONFIRMAR: 'Pac_Reserva_Confirmar',
} as const

export const PRE_SCHEDULE_CARD_INTERACTIONS = {
  CLICK: 'click',
} as const
